'use client';
import { useState, useEffect, ChangeEvent } from 'react';
import { useGetTermsDetails } from '../api/getTermsOfService';
import { useParams } from 'react-router-dom';

export default function TermsOfService() {
  const getUrlDetails = useGetTermsDetails();
  const { slug } = useParams();
  const [termsOfService, setTermsOfService] = useState('');
  useEffect(() => {
    getTermsOfService();
  }, []);
  const getTermsOfService = async () => {
    if (slug) {
      const res = await getUrlDetails.mutateAsync({
        slug: slug,
      });
      if (res && res.businessInfo) {
        setTermsOfService(res.businessInfo?.termsOfServiceUrl);
      }
    }
  };

  return (
    <>
      <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
        <div>
          <iframe
            title="PDF Viewer"
            src={termsOfService}
            width="100%"
            height="1000px"
            style={{ border: 'none' }}
          ></iframe>
        </div>
      </div>
    </>
  );
}
